export default "__VITE_ASSET__280bff34__"